import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export class InvoiceItem {

    public form: FormGroup;

    public cities = [];
    public states = [];
    public counties = [];

    constructor(private formBuilder: FormBuilder) {
        this.form = this.formBuilder.group({
            make: ['', Validators.required],
            model: ['', Validators.required],
            serialNumber: [''],
            year: ['', Validators.required],
            itemDescription: [''],
            equipmentCost: ['', Validators.required],
            condition: ['true', Validators.required],
            sameAddres: ['true', Validators.required],
            address: ['', Validators.required],
            unit: [''],
            zip: ['', Validators.required],
            city: ['', Validators.required],
            state: ['', Validators.required],
            county: ['', Validators.required],
            invoiceNumber: ['', Validators.required]
        });
    }
    get iForm () { return this.form.controls; }

    decode(data: any) {
        this.iForm.make.setValue(data.make);
        this.iForm.model.setValue(data.model);
        this.iForm.serialNumber.setValue(data.serialNumber);
        this.iForm.year.setValue(data.year);
        this.iForm.itemDescription.setValue(data.description);
        this.iForm.equipmentCost.setValue(data.cost);
        this.iForm.condition.setValue(data.condition);
        this.iForm.sameAddres.setValue(data.lesseeAddress ? 'true' : 'false');
        this.iForm.address.setValue(data.streetAddress);
        this.iForm.unit.setValue(data.unit);
        this.iForm.zip.setValue(data.zipCode);
        this.iForm.city.setValue(String(data.city).toUpperCase());
        this.iForm.state.setValue(data.state);
        this.iForm.county.setValue(String(data.county).toUpperCase());
        this.iForm.invoiceNumber.setValue(data.invoiceNumber);
        this.iForm.invoiceNumber.setValue((data.make.length || data.model.length || data.year.length) ? '0' : '');
    }

    encode(): any {
        return {
            city: this.iForm.city.value,
            condition: this.iForm.condition.value === 'true',
            cost: Number(this.iForm.equipmentCost.value),
            county: this.iForm.county.value,
            description: this.iForm.itemDescription.value,
            lesseeAddress: this.iForm.sameAddres.value === 'true',
            make: this.iForm.make.value,
            model: this.iForm.model.value,
            serialNumber: this.iForm.serialNumber.value,
            state: this.iForm.state.value,
            streetAddress: this.iForm.address.value,
            supplier: '',
            unit: this.iForm.unit.value,
            year: Number(this.iForm.year.value),
            zipCode: this.iForm.zip.value
        };
    }
}
